import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import Handler from '../../Handler';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import IconButton from '@mui/material/IconButton';

export const SearchFilter = (props) => {
  const { data, onChange, onSearch, onReset } = props;

  const handleSelectChange = (e, index) => {
    onChange(e.target.value, index);
  };

  const handleInputChange = (e, index) => {
    onChange(e.target.value, index);
  };

  const handleDateChange = (new_value, index) => {
    onChange(new_value, index);
  };

  const handleKeyPress = (e, index) => {
    if (e.key === 'Enter') {
      let body = Handler.filterToBody(data);
      onSearch(body);
    }
  };
  
  return (
    <article className='search-filter'>
      <header>
        <span>검색 필터</span>
        <div className='flex space-x-2'>
          {onReset && <Button
            variant='contained'
            onClick={() => {
              onReset();
            }}
          >
            초기화
          </Button>}
          <Button
            variant='contained'
            onClick={() => {
              let body = Handler.filterToBody(data);
              onSearch(body);
            }}
          >
            검색
          </Button>
        </div>
      </header>

      <ul>
        {data.map((item, index) => {
          const { type, value, label } = item;
          switch (type) {
            case 'select': {
              return (
                <li key={label}>
                  <header>
                    <span>{label}</span>
                  </header>
                  <FormControl variant='outlined' fullWidth>
                    <InputLabel>{label}</InputLabel>
                    <Select
                      value={value}
                      label={label}
                      onChange={(e) => {
                        handleSelectChange(e, index);
                      }}
                    >
                      {item.menus.map((menu_item, meni_index) => {
                        return <MenuItem key={menu_item.label} value={menu_item.value}>{menu_item.label}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </li>
              );
            }
            case 'input': {
              return (
                <li key={label}>
                  <header>
                    <span>{label}</span>
                  </header>
                  <TextField
                    type={item.inputType}
                    value={value}
                    onChange={(e) => {
                      handleInputChange(e, index);
                    }}
                    onKeyPress={(e) => handleKeyPress(e, index)}
                    fullWidth
                    label={label}
                    variant='outlined'
                  />
                </li>
              );
            }
            case 'date': {
              return (
                <li key={label}>
                  <header>
                    <span>{label}</span>
                  </header>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat={'yyyy-MM-dd'}
                        mask={'____-__-__'}
                        disableMaskedInput={true}
                        label={label}
                        value={value}
                        onChange={(e) => {
                          handleDateChange(e, index);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                    <div
                      className='clear__box'
                      onClick={() => {
                        handleDateChange(null, index);
                      }}
                    >
                      <IconButton disabled={!value} aria-label='fingerprint' color='info'>
                        <HighlightOffIcon />
                      </IconButton>
                    </div>
                  </FormControl>
                </li>
              );
            }
            case 'date-time': {
              return (
                <li key={label}>
                  <header>
                    <span>{label}</span>
                  </header>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        inputFormat={'yyyy-MM-dd HH:mm'}
                        mask={'____-__-__ __:__'}
                        disableMaskedInput={true}
                        label={label}
                        value={value}
                        onChange={(e) => {
                          handleDateChange(e, index);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </li>
              );
            }
            default: {
              return (
                <li>
                  <header>
                    <span>{label}</span>
                  </header>
                  <span>{value}</span>
                </li>
              );
            }
          }
        })}
      </ul>
    </article>
  );
};
